import * as PSLib from 'poolside-js-lib';
import { default as trHU } from './hu_HU.json';
import { default as trUS } from './en_US.json';


const locale = PSLib.Utils.locale;
PSLib.Utils.setupLocale(
    locale, 
    [ trHU, trUS ],
    process.env.REACT_APP_WARNING_ON_MISSING_TRANSLATION === "true",
);
export default locale;
